<script setup lang="ts">
import { WEB_APP_URL } from '~/constants/website'

const solutions = [
  'Dana COD masuk saldo aktif di hari yang sama paket sampai ke tujuan.',
  'Tarik saldo aktif ke rekeningmu kapan saja secara real time.',
  'Dana COD cair hingga 50% saat paket dibawa kurir dengan COD Advance.'
]
</script>

<template>
  <div class="flex flex-col gap-11 py-4 lg:py-16">
    <UiSectionWrapper
      image-class="lg:order-first"
      title="Kirim Paket COD dari Berbagai Ekspedisi"
      description="Dengan pengiriman reguler, kamu bisa melayani pembayaran COD pelanggan tanpa menggunakan marketplace."
      hero-image="/images/batch-2/regular-add-1.webp"
    >
      <template #action>
        <div class="mt-6 lg:mt-12 flex flex-col gap-11">
          <div class="flex flex-col gap-6 text-lg leading-7">
            <div
              v-for="(solution, index) in solutions"
              :key="index"
              class="flex gap-2"
            >
              <Icon
                class="text-primary flex-none"
                name="material-symbols:verified"
                size="24px"
              />
              <p class="text-sm lg:text-lg flex-1">
                {{ solution }}
              </p>
            </div>
          </div>
          <div class="flex items-center">
            <UiButton
              variant="primaryOutline"
              label="Lihat Selengkapnya"
              :to="$utm.utmUrl(WEB_APP_URL)"
            />
          </div>
        </div>
      </template>
    </UiSectionWrapper>
  </div>
</template>
